
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"レイヤー 2"}},[_c('g',{attrs:{"data-name":"レイヤー 1"}},[_c('path',{attrs:{"d":"M16 1A15 15 0 111 16 15 15 0 0116 1m0-1a16 16 0 1016 16A16 16 0 0016 0z"}}),_c('path',{attrs:{"d":"M8 26a.5.5 0 01-.17-1l4.78-1.75v-1.62a9.57 9.57 0 01-3.33-4.24A1.37 1.37 0 018 16l-.16-1.77a1.42 1.42 0 011-1.4C9.29 8.62 12.36 5.5 16 5.5s6.71 3.12 7.26 7.33a1.37 1.37 0 01.95 1.33L24.05 16a1.36 1.36 0 01-1.31 1.37c-1.23 3.07-4.12 5.44-6.72 5.44a.5.5 0 01-.5-.5.5.5 0 01.5-.5c2.26 0 4.9-2.29 5.9-5.11a.5.5 0 01.47-.33h.37c.17 0 .31-.19.31-.41l.16-1.86a.35.35 0 00-.31-.36.59.59 0 01-.59-.46C22 9.42 19.24 6.5 16 6.5s-5.95 2.92-6.31 6.8a.5.5 0 01-.5.46.38.38 0 00-.4.4L9 15.93c0 .27.14.46.31.46h.37a.5.5 0 01.47.33 8.49 8.49 0 003.29 4.22.5.5 0 01.22.42v2.3a.5.5 0 01-.32.47L8.17 26A.47.47 0 018 26zM24 26a.47.47 0 01-.17 0l-5.12-1.87a.49.49 0 01-.29-.64.5.5 0 01.64-.3l5.11 1.87A.5.5 0 0124 26z"}})])])])
          )
        }
      }
    